document.addEventListener('turbolinks:load', function () {

  const select = document.getElementById('customer_visit_reason');
  const field = document.getElementById('introducer_name_field');

  function toggleIntroducerField() {
    field.style.display = (select.value === 'introducer') ? 'block' : 'none';
  }

  if (select && field) {
    toggleIntroducerField(); // 初回呼び出し
    select.addEventListener('change', toggleIntroducerField);
  }

  const checkbox = document.getElementById('privacy_check');
  const submitButton = document.querySelector('.training-event-form__submit-button');

  if (checkbox && submitButton) {
    submitButton.disabled = !checkbox.checked;
    checkbox.addEventListener('change', function () {
      submitButton.disabled = !this.checked;
    });
  }
});
